var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1247 25.0591L8.18164 18.1144L10.4955 15.8005L15.1247 20.4282L24.38 11.1713L26.6955 13.4867L15.1247 25.0591Z",
    fill: "#78D38A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 18C0 8.05909 8.05909 0 18 0C27.9409 0 36 8.05909 36 18C36 27.9409 27.9409 36 18 36C8.05909 36 0 27.9409 0 18ZM18 32.7273C16.066 32.7273 14.1509 32.3463 12.3641 31.6062C10.5773 30.8661 8.9538 29.7813 7.58625 28.4138C6.21869 27.0462 5.13389 25.4227 4.39377 23.6359C3.65366 21.8491 3.27273 19.934 3.27273 18C3.27273 16.066 3.65366 14.1509 4.39377 12.3641C5.13389 10.5773 6.21869 8.9538 7.58625 7.58625C8.9538 6.21869 10.5773 5.13389 12.3641 4.39377C14.1509 3.65366 16.066 3.27273 18 3.27273C21.9059 3.27273 25.6519 4.82435 28.4138 7.58625C31.1757 10.3481 32.7273 14.0941 32.7273 18C32.7273 21.9059 31.1757 25.6519 28.4138 28.4138C25.6519 31.1757 21.9059 32.7273 18 32.7273Z",
    fill: "#78D38A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIco);
export default __webpack_public_path__ + "static/media/check_ico.61c219f9fa1a7295dfa9b2be6b100bc2.svg";
export { ForwardRef as ReactComponent };